import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import color from 'tinycolor2';

const pulsate = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

const PlaceholderText = styled.div`
  height: ${(props) => props.height}px;
  border-radius: ${(props) => (props.height / 2)}px;
  background-color: ${(props) => color(props.theme['color.text.light']).setAlpha(0.1).toString()};
  animation: ${pulsate} 1s linear infinite;
  flex: 1;
  max-width: ${(props) => props.maxWidth}px;
  min-width: ${(props) => props.minWidth}px;
  margin-left: ${(props) => props.marginLeft}px;
`;

PlaceholderText.propTypes = {
  height: PropTypes.number.isRequired,
  maxWidth: PropTypes.number.isRequired,
};

export default PlaceholderText;
